<template>
  <div class="wrapper">
      <section class="side">
        <p class="main-msg">{{ $t('sloganGuest') }} </p>
        <!-- <p class="main-msg">{{ $t('sloganMain2') }} </p> -->
        <!-- <p class="secondary-msg">{{ $t('productVision1') }}</p> -->
        <!-- <router-link :to="'/' + $i18n.locale"><img src="../assets/static/icons/expar_logo_new2.svg" alt="expar logo"></router-link> -->
      </section>

      <section class="main">
        <div class="signInLogo">
          <img src="../assets/static/icons/expar_logo_new2.svg" alt="expar_logo" />
        </div>
        <SocialSignUp class="signUpBtn" :type="type" :isChckoutLogin="isChckoutLogin" @login-response="loginResponse" />
        <GuestLogin class="signUpBtn" @login-response="loginResponse" />

        <!-- <br/>
        <div class="divider">
            <hr class="left"/>or<hr class="right" />
        </div>
        <form @submit.prevent="login">
          <div class="form-control">
            <input 
              v-model="email" 
              type="email" 
              name="email" 
              :placeholder="$t('email')"
              value v-on="$listeners" 
              @blur="$v.email.$touch()" 
              v-on:input="resetErrorMessage"
              :class="{ error: $v.email.$error }" >
            <i class="fas fa-envelope"></i>
          </div>
          <div class="form-control">
            <input 
              v-model="password" 
              :class="{ error: $v.password.$error }" 
              :type="passwordFieldType" 
              name="password" 
              :placeholder="$t('password')"
              @blur="$v.password.$touch()"
              v-on="$listeners" 
              v-on:input="resetErrorMessage"
              value >
            <i class="fas fa-lock"></i>
            <button class="eyeIcon" type="password" @click="switchVisibility">
              <span class="input-group-text" @click="showPassword = !showPassword">
                <i class="fa" :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']" aria-hidden="true"></i>
              </span>
            </button>
          </div>

          <div class="options-01">
            <br/>
            <a class="forgotPass" data-qa="forgotPasswordLink" @click="$bvModal.show('forgot-password')">{{ $t('forgotPass') }}</a>
          </div>

          <template v-if="$v.email.$error">
            <div v-if="!$v.email.email" class="errorMessage">
              {{ $t('emailValid') }}
            </div>
            <div v-if="!$v.email.required" class="errorMessage">
              {{ $t('emailReq') }}
            </div>
          </template>
          <template v-if="$v.password.$error">
            <div v-if="!$v.password.required" class="errorMessage">
             {{ $t('passReq') }}
            </div>
          </template>

          <div v-if="this.error" class="errorMessage">
            {{ this.error }}
          </div>

          <button :disabled="$v.$invalid" class="action" type="submit" name="button">{{ $t('login') }}</button>
        </form> -->

        <!-- <div class="login">
          <p> {{ $t('notHaveAccount') }}</p>
          <button @click="redirectRegister">{{ $t('signup') }}</button>
        </div> -->
      </section>
      <b-modal id="forgot-password" hide-footer  no-stacking>
        <template v-slot:modal-title>
          {{ $t('sendPass') }}
        </template>
        <forgotPassword 
          @success-mail="hideForgotPasswordModel"
        />
      </b-modal>
      <sweet-modal icon="success" ref="modalSuccess" name="successModal">
            {{ $t('mailSentSuccess') }}
      </sweet-modal>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import SocialSignUp from '@/components/ui/SocialSignUp'
import forgotPassword from '../components/common/forgotPassword'
import GuestLogin from '@/components/ui/GuestLogin'
import { SweetModal } from 'sweet-modal-vue';


// import { mapGetters } from 'vuex'

export default {
  components: {
    SocialSignUp,
    GuestLogin,
    forgotPassword,
    SweetModal
  },
  data() {
    return {
      email: '',
      password: '',
      error: null,
      type: "login",
      passwordFieldType: 'password',
      showPassword: false
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  methods: {
    login() {
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password,
        })
        .then(() => {
          const user = JSON.parse(localStorage.getItem('user'))
          const { role, id } = user
          if (this.isChckoutLogin) {
          	this.$emit('login-response', user)
          } else {
            if (role === 'admin') {
              this.$router.push({ name: 'adminPanel' }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'user') {
              this.$router.push({ name: 'user', params: { userId: id } }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'cleaner') {
              this.$router.push({ name: 'cleanerPanel' }) // automatically redirect to dashboard when user click "register"//
            } else if (role === 'support') {
              this.$router.push({ name: 'supportPanel' }) // automatically redirect to dashboard when user click "register"//
            } else {
              this.$router.push({ name: 'dashboard' }) // automatically redirect to dashboard when user click "register"//
            }
          }
        })
        .catch((err) => {
          // console.log('Show error notification!')
          this.error = err.data.message
        })
      this.$v.$touch()
      if (!this.$v.$invalid) {
        // console.log("form submitted:", this.email);
      }
    },
    redirectRegister() {
      if(this.isChckoutLogin) {
        this.$emit('register-redirect', true)
      } else {
        this.$router.push({ name: 'register', params: { lang:  this.$i18n.locale} }) 
      }
    },
    resetErrorMessage() {
      if (this.error) this.error = null
    },
    async loginResponse() {
      const user = JSON.parse(localStorage.getItem('user'))
      this.$emit('login-response', user)
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    hideForgotPasswordModel() {
      this.$refs.modalSuccess.open()
      this.$bvModal.hide('forgot-password')
    }
  },
  props: {
    isChckoutLogin: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

.logo-img path {
  fill: var(--primary);
}
.wrapper {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 60% 1fr;
    color: #696969;
}

.eyeIcon {
  position: absolute;
    top: 20px;
    right: 20px;
}

.signInLogo {
  width: 60%;
  margin-bottom: 3em;
}
.signUpBtn {
  margin: 1em 0em;
}
.cls-1 {
  fill: var(--primary);
}

.shadow {
  -webkit-filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  /* Similar syntax to box-shadow */
  }
section {
    display        : flex;
    flex-direction : column;
    justify-content: center;
    align-items    : center;
    padding        : 48px;
}
.error {
  background-color:none !important;
  border-color: none !important;
}
.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}
.forgotPass {
  color: var(--bg) !important;
  background-color: none !important;
  text-decoration-line: none;
  cursor: pointer;
}
.forgotPass:hover {
  text-decoration-line: underline;
}

.forgotPass:active {
  color: var(--primary) !important;
  text-decoration-line: none;
}

.close {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}


.side {
  	// background: linear-gradient(16deg, rgba(76,158,134,1) 0%, rgba(61,113,109,1) 8%, rgba(47,71,85,1) 38%, rgba(44,62,80,1) 47%, rgba(44,62,80,1) 50%, rgba(44,62,80,1) 80%);  /* background: url("../assets/static/images/background.png")no-repeat; */
	background: url('../../src/assets/static/images/bg/landing_header.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
}

.side img {
    width    : 30%;
}

.side p {
    max-width     : 500px;
    color         : #ddfdff;
    letter-spacing: 1px;
    line-height   : 1.8em;
    margin-bottom : 40px;
}

.side .main-msg {
    color        : var(--primaryDark);
    font-size    : 3.2em;
    font-weight  : bold;
    line-height  : 1.5em;
    margin-bottom: 20px;
}

.title {
    font-size     : 3em !important;
    font-weight   : bold;
    text-align    : center;
    letter-spacing: 1px;
    color: var(--bg);
}

.divider {
  color: var(--bg);
	width: 100%;
	text-align:center;
}

.divider hr {
	margin-left:auto;
	margin-right:auto;
	width:40%;

}

.left {
	float:left;
}

.right {
	float:right;
}

.welcome-message {
    text-align   : center;
    font-size    : 1.1em;
    line-height  : 28px;
    margin-bottom: 10px;
}

form {
    width         : 100%;
    max-width: 400px;
    display       : flex;
    flex-direction: column;
}

.form-control {
    width        : 100%;
    position     : relative;
    margin-bottom: 24px;
    border: none !important;
}

input,
button {
    border       : none;
    outline      : none;
    border-radius: 30px;
    font-size    : 1.1em;
}

input {
    width         : 100%;
    background    : #e6e6e6;
    color         : #333;
    letter-spacing: 0.5px;
    padding       : 14px 64px;
}

input~i {
    position  : absolute;
    left      : 22px;
    top       : 80%;
    transform : translateY(-50%);
    color     : var(--gray);
    transition: color 0.4s;
    font-size: 1.3em;
}

input:focus~i {
    color: #0E484B;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

.login {
    position       : absolute;
    bottom         : 32px;
    display        : flex;
    justify-content: center;
    align-items    : center;
}

.login button {
    margin-left  : 16px;
    background   : none;
    color: var(--bg);
    border-bottom: 2px solid var(--bg);
    border-radius: 0;
    padding      : 4px;
    cursor       : pointer;
    font-weight  : bold;
}

.login button:hover {
    color: var(--primary);
    border-bottom: 2px solid var(--primary);
}


.login p {
  margin-bottom: 0;
}

/* ----  Responsiveness   ----  */
@media (max-width: 480px) {
.section {
  padding: 48px 20px 60px 20px !important;;
}
.login {
  bottom: 5px;
}
}

@media (max-width: 780px) {
    .wrapper {
        grid-template-columns: 1fr;
    }

    .side {
        display: none;
    }
    .section {
      padding-bottom: 0;
    padding-top: 0;
    }
}

@media (min-width: 775px) {
.close {
  display: none;
}
}

// media queries for common device breakpoints

//Galaxy Fold //
@media only screen and (min-device-width: 270px) and (max-device-width: 280px) {

}
//
@media only screen and (min-device-width: 281px) and (max-device-width: 320px) {

}
//iPhone 5 //
@media only screen and (min-device-width: 321px) and (max-device-width: 359px) and (orientation: portrait) {

}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
section {
  padding: 0px 100px;
  justify-content: inherit;
}
.signInLogo {
  width: 20%;
  margin:0;
}
}
//Galaxy S5/S8/Moto S4  and Note 3//
@media only screen and (min-device-width: 360px) and (max-device-width: 374px) and (orientation: portrait) {

}
@media screen and (device-width: 320px) and (device-height: 640px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
section {
  padding: 0px 100px;
  justify-content: inherit;
  width: 135vh !important;
}
}

/* ----------- iPhone 6, 6S, 7 and 8 ----------- */

/* Portrait */
@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 667px) 
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: portrait) { 

}

/* Landscape */
@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 667px) 
  and (-webkit-min-device-pixel-ratio: 2)
  and (orientation: landscape) { 
section {
  padding: 0px 100px;
  justify-content: inherit;
}
.signInLogo {
  width: 20%;
  margin:0;
}
.wrapper {
  min-height: 70vh;
}
.side {
  display: none;
}
}

/* ----------- iPhone 6+, 7+ and 8+ ----------- */

/* Portrait */
@media only screen 
  and (min-device-width: 414px) 
  and (max-device-width: 736px) 
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: portrait) { 

}

/* Landscape */
@media only screen 
  and (min-device-width: 414px) 
  and (max-device-width: 736px) 
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: landscape) { 
section {
  padding: 0px 100px;
  justify-content: inherit;
  width: 115vh !important;
}
.signInLogo {
  width: 20%;
  margin:0;
}
.wrapper {
  min-height: 70vh;
}
.side {
  display: none;
}
}

/* ----------- iPhone X ----------- */

/* Portrait */
@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 812px) 
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: portrait) { 

}

/* Landscape */
@media only screen 
  and (min-device-width: 375px) 
  and (max-device-width: 812px) 
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: landscape) { 
section {
  padding: 0px 100px;
  justify-content: inherit;
  width: 130vh;
}
.signInLogo {
  width: 20%;
  margin:0;
}
.wrapper {
  min-height: 70vh;
}
.side {
  display: none;
}
}

//iPhone 12/12Pro //
@media only screen and (min-device-width: 390px) and (max-device-width: 413px) and (orientation: portrait) {

}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width: 414px) and (max-device-width: 440px) and (orientation: portrait) {

}
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
section {
  padding: 0px 100px;
  justify-content: inherit;
}
.signInLogo {
  width: 20%;
  margin:0;
}
.wrapper {
  min-height: 70vh;
}
.side {
  display: none;
}
}

/* ----------- iPad 1, 2, Mini and Air ----------- */

/* Portrait and Landscape */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 1) {

}

/* Portrait */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1) {

}

/* Landscape */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1) {

}

/* ----------- iPad 3, 4 and Pro 9.7" ----------- */

/* Portrait and Landscape */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* Portrait */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* Landscape */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* ----------- iPad Pro 10.5" ----------- */

/* Portrait and Landscape */
@media only screen 
  and (min-device-width: 834px) 
  and (max-device-width: 1112px)
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen 
  and (min-device-width: 834px) 
  and (max-device-width: 834px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen 
  and (min-device-width: 1112px) 
  and (max-device-width: 1112px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 2) {

}

/* ----------- iPad Pro 12.9" ----------- */

/* Portrait and Landscape */
@media only screen 
  and (min-device-width: 1024px) 
  and (max-device-width: 1366px)
  and (-webkit-min-device-pixel-ratio: 2) {
}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen 
  and (min-device-width: 1024px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {
.wrapper {
  min-height: 50vh;
  grid-template-columns: 50% 1fr;
}
}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen 
  and (min-device-width: 1366px) 
  and (max-device-width: 1366px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 2) {
.wrapper {
  min-height: 70vh;
  grid-template-columns: 50% 1fr;
}
}

</style>